<div class="skeleton-row">
  <div class="skeleton-row__avatar" [class.tui-skeleton]="true" [class.tui-skeleton_rounded]="true"></div>

  <div class="skeleton-row__body" [class.tui-skeleton]="true" [class.tui-skeleton_rounded]="true"></div>
</div>
